import PDFViewer from 'extensions/PDFViewer/PDFViewer';
import 'extensions/quick-order';
import 'extensions/ui-components/g-modal';
import 'extensions/warranty-lookup';
import {PageManager} from 'genesis-packages/core';
import './ACLN.scss';

export default class ACLN extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

	onReady () {

		new PDFViewer(this.pageContext.PDF_Viewer_Url, false);

	}

};
